export default __webpack_public_path__ + "static/media/halas1.82b0cf0a.jpg";